module.exports = __webpack_public_path__ + "img/CAL-UHF-S.3e377372.webp";